import {
  AfterContentChecked,
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
}

  from '@angular/core';
import { Observable, pipe } from 'rxjs';
import { delay, distinctUntilChanged, skip, startWith, tap } from 'rxjs/operators';

import {
  LoaderService
}

  from '../../services/loader.service';

@Component({
  selector: 'app-my-loader',
  templateUrl: './my-loader.component.html',
  styleUrls: ['./my-loader.component.scss']
}

) export class MyLoaderComponent {

  isLoading$: Observable<boolean>;

  constructor(private loaderService: LoaderService, private changeDetector: ChangeDetectorRef) {
    this.isLoading$ = this.loaderService.Loading.pipe(
      delay(0),
      tap(res => res)
    )
  }
}
